import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { BaseEntityResponseDto } from '@sphere/shared/domain';
import { SubjectExternalSummaryDto } from '../../activity/response/subject-external-summary.dto';
import { ClassLevelSummaryDto } from '../../activity/response/class-level-summary.dto';

class LearningPathSummaryDto {
  @ApiProperty({ type: 'string' })
  id!: string;

  @ApiProperty({ type: 'string' })
  title!: string;

  @ApiPropertyOptional({ type: 'string', nullable: true })
  description?: string | null;
}

export class LearningPathTeachingAssignmentResponseDto extends BaseEntityResponseDto {
  @ApiProperty({ type: 'string' })
  learningPathId!: string;

  @ApiProperty(
    {
      type: 'string',
      description: "ID de l'enseignement",
    }
  )
  teachingId!: string;

  @ApiPropertyOptional({ type: 'string', nullable: true })
  subjectExternalId?: string | null;

  @ApiPropertyOptional({ type: 'string', nullable: true })
  classLevelExternalId?: string | null;

  @ApiPropertyOptional({ type: 'string', nullable: true })
  establishmentId?: string | null;

  @ApiPropertyOptional({ type: 'string', nullable: true })
  schoolYearId?: string | null;

  @ApiPropertyOptional({ type: 'string', format: 'date-time', nullable: true })
  availableFrom?: Date | null;

  @ApiPropertyOptional({ type: 'string', format: 'date-time', nullable: true })
  dueAt?: Date | null;

  @ApiPropertyOptional({ type: Boolean, nullable: true })
  isVisible?: boolean | null;

  @ApiPropertyOptional({ type: () => LearningPathSummaryDto })
  learningPath?: LearningPathSummaryDto;

  @ApiPropertyOptional({ description: 'Sujet externe lié', type: () => SubjectExternalSummaryDto })
  subjectExternal?: SubjectExternalSummaryDto;

  @ApiPropertyOptional({ description: 'Niveau de classe lié', type: () => ClassLevelSummaryDto })
  classLevel?: ClassLevelSummaryDto;
}

